module.exports = __webpack_public_path__ + "img/logo2.fd17801c.png";